import { CHCStickyBanner } from "./sticky-banner.component.js";
customElements.define("chc-sticky-banner", CHCStickyBanner);
export {
  CHCStickyBanner
};
//# sourceMappingURL=sticky-banner.js.map
